import { TextMessage } from "@/store/chats/types";

export const getIsAttachmentsImageDisplayed = (message: TextMessage): boolean =>
  Boolean(
    message?.imageAttachments?.length && message?.imageAttachments?.length > 1,
  );
